import { useState } from "react";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import Button from "../Reusable/Button";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { usePDFPrintHook, useDownload } from "@careinfo/layout";
import moment from "moment";
import Modal from "../Reusable/Modal";
import MakePayment from "./MakePayment";
import { get } from "react-hook-form";

const CargoInvoicePreview = (props: any) => {
  const { order, id } = props;
  const [makePayment, setMakePayment] = useState(false);
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });
  const { data: clientData } = useGetHook({
    queryKey: [`client-setting`],
    url: `${APIS.CLIENT_SETTING}`,
    params: {},
  });
  const { download } = useDownload();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handleDownloadExcel = async () => {
    try {
      await download(
        `${APIS.MERCHANT_INVOICE}${id}/download-order/`,
        `${order?.user?.full_name}-invoice-${moment().format(
          "MMMM-Do-YYYY-h-mm-ss"
        )}.xlsx`
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrint = async () => {
    const url = `${APIS.MERCHANT_INVOICE}${id}/print-pdf-invoice/?type=packaging-invoice`;
    let formData = {};
    try {
      const res = await downloadPrint(url);
    } catch (err) {
      console.log(err);
    }
  };
  const handleShipmentPrint = async () => {
    const url = `${APIS.MERCHANT_INVOICE}${id}/print-pdf-invoice/`;
    let formData = {};
    try {
      const res = await downloadPrint(url);
    } catch (err) {
      console.log(err);
    }
  };

  const chargeKeys = Array.from(
    new Set(
      order?.orders?.flatMap(
        (item: any) => item.charges?.flatMap((c) => Object.keys(c)) ?? []
      )
    )
  ).filter((key) => key !== "flat");
  const getChargeTotal = (
    charges: Record<string, number>[] = [],
    key: string
  ) => charges.reduce((sum, obj) => sum + (obj[key] || 0), 0);
  console.log("chargeKeys", chargeKeys);

  const getOtherChargesTotal = (
    charges: Record<string, number>[] = [],
    excludeKeys: string[] = ["freight", "tia", "flat"]
  ) =>
    charges.reduce((sum, obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (!excludeKeys.includes(key)) {
          sum += Number(value || 0);
        }
      });
      return sum;
    }, 0);

  const EXCLUDED_CHARGES = ["tia", "freight", "flat"];

  const formatChargeLabel = (key: string) =>
    key.replace(/_/g, " ").toUpperCase();

  const getRowDescription = (charges: Record<string, number>[] = []) => {
    return chargeKeys
      .filter(
        (key: string) =>
          !EXCLUDED_CHARGES.includes(key) && getChargeTotal(charges, key) > 0
      )
      .map(formatChargeLabel)
      .join(", ");
  };

  return (
    <>
      <div className={tw` px-4 `}>
        <div className={tw`mb-4 flex justify-end gap-x-3 `}>
          <div className={tw`w-1/2 justify-end flex gap-x-8`}>
            <Button
              label="Print"
              type="button"
              onClick={handleShipmentPrint}
              isLoading={isPrintLoading}
            />
            {/* <Button
              label="Invoice Print"
              type="button"
              onClick={handlePrint}
              isLoading={isPrintLoading}
            /> */}
            <Button
              label="Download"
              type="button"
              onClick={handleDownloadExcel}
            />
            {userProfileType?.is_merchant ? (
              ""
            ) : (
              <AccessControl
                children={
                  <Button
                    label={order?.status === "paid" ? "PAID" : "Make Payment"}
                    type="button"
                    disabled={order?.status !== "pending"}
                    onClick={() => setMakePayment(!makePayment)}
                  />
                }
                allowedPermissions={["can_update_merchant_invoice"]}
              />
            )}
          </div>
        </div>
        <div
          className={tw`flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl `}
        >
          <div className={tw`flex justify-between`}>
            <div>
              <img
                className={tw`h-[4rem] object-contain`}
                src={clientData?.logo}
                alt="logo"
              />
            </div>
            {/* Col */}

            <div className={tw`text-right`}>
              <h2
                className={tw`text-2xl md:text-3xl font-semibold text-gray-500 `}
              >
                Statement #
              </h2>
              <span className={tw`mt-1 block text-gray-500`}>
                {order?.invoice_id}
              </span>
              <address className={tw`mt-1 not-italic text-gray-500 `}>
                {clientData?.address ?? "N/A"}
                <br />
              </address>
            </div>
            {/* Col */}
          </div>
          <div className={tw`mt-8 text-sm grid sm:grid-cols-2 gap-3`}>
            <div>
              <h3 className={tw` font-semibold text-gray-500 `}>Bill to:</h3>
              <h3 className={tw` font-semibold text-gray-500  capitalize`}>
                {order?.user?.full_name ?? "N/A"}
              </h3>
              <p className={tw`font-semibold text-gray-500   `}>
                PAN/VAT :{order?.merchant_pan}
              </p>
              <address className={tw`mt-2 not-italic text-gray-500`}>
                {order?.user?.mobile_number ?? "N/A"},<br />
                {order?.user?.email ?? "N/A"},<br />
                Kathmandu, Nepal
                <br />
              </address>
            </div>
            {/* Col */}

            <div className={tw`sm:text-right space-y-2`}>
              {/* Grid */}
              <div
                className={tw`grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2`}
              >
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt
                    className={tw`col-span-3 text-sm font-semibold text-gray-500  `}
                  >
                    Statement date:
                  </dt>
                  <dd className={tw`col-span-2  text-sm text-gray-500`}>
                    {moment(order?.created).format("YYYY/MM/DD ")}
                  </dd>
                </dl>
                <dl className={tw`grid grid-cols-5 text-sm gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment Method:
                  </dt>
                  {/* <dd className={tw`col-span-2  text-gray-500 uppercase`}>
                    {order?.payment_method}
                  </dd> */}
                  <dd
                    className={tw`col-span-2 text-xs  text-gray-500 uppercase mt-1`}
                  >
                    {Array.isArray(order?.payment_method) ? (
                      <div>
                        {order?.payment_method.map((p: any, i: number) => (
                          <div key={i}>
                            {p.payment_method} (Rs.{p.amount})
                          </div>
                        ))}
                      </div>
                    ) : typeof order?.payment_method === "object" &&
                      order?.payment_method !== null ? (
                      <span>
                        {order?.payment_method.payment_method} (Rs.
                        {order?.payment_method.amount})
                      </span>
                    ) : (
                      <span>{order?.payment_method ?? "N/A"}</span>
                    )}
                  </dd>
                </dl>
                <dl className={tw`grid sm:grid-cols-5  text-sm gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment date:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    {order?.settlement_date
                      ? moment(order?.settlement_date).format("YYYY/MM/DD")
                      : "N/A"}
                  </dd>
                </dl>
                <dl className={tw`grid  text-sm  sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment Status:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                    {order?.status}
                  </dd>
                </dl>
                {order?.date_range && (
                  <dl className={tw`grid  text-sm  sm:grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Date Range:
                    </dt>
                    <dd
                      className={tw`col-span-2 text-gray-500 uppercase whitespace-no`}
                    >
                      {order?.date_range?.lower},{order?.date_range?.upper}
                    </dd>
                  </dl>
                )}
              </div>
              {/* End Grid */}
            </div>
            {/* Col */}
          </div>
          <div className={tw`overflow-x-auto w-full`}>
            <table
              className={tw`mt-6 w-full border border-gray-400 rounded-lg text-sm`}
            >
              <thead>
                <tr className={tw`text-center border-b border-gray-400 `}>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    SN
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    Date
                  </th>

                  {/* <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    FORWARDING NO.
                  </th> */}
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    INVOICE NO.
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    HWB
                  </th>
                  {/* <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    Sender
                  </th> */}

                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    RECEIVER
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    DESTINATION
                  </th>

                  {/* <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    Country Code
                  </th> */}

                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    SERVICE
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    Pieces
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    WT(AW,VW,CW)
                  </th>
                  {/* {chargeKeys.map((key: any) => (
                    <th
                      key={key}
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      {key}
                    </th>
                  ))} */}
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    Description
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    RATE(/KG)
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    COST + TIA
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    OTHER CHARGES
                  </th>
                  <th
                    className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {order?.orders?.map((item: any, index: number) => (
                  <tr key={index} className={tw`text-center text-sm`}>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p className={tw`font-medium text-gray-500 `}>
                        {index + 1}
                      </p>
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p
                        className={tw`text-sm text-gray-500 whitespace-nowrap `}
                      >
                        {moment(item?.created).format("YY-MM-DD HH:mm:ss")}
                      </p>
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p className={tw` text-sm text-gray-500 `}>
                        {item?.order_number}
                      </p>
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p className={tw` text-sm text-gray-500 `}>
                        {item?.tracking_number}
                      </p>
                    </td>

                    {/* <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p className={tw` font-medium text-gray-500 `}>
                        {item?.forwarding_no}
                      </p>
                    </td> */}
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p
                        className={tw`font-medium text-gray-500  whitespace-nowrap flex flex-col`}
                      >
                        {item?.receiver?.full_name}

                        {/* <p className={tw`font-sm`}>
                            {item?.receiver.primary_contact}
                          </p> */}
                        {/* <p className={tw`font-sm `}>
                            {item?.receiver.address_1}
                          </p> */}
                      </p>
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      {item?.receiver?.code || item?.receiver?.country}
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      {item?.service_type?.name}
                    </td>

                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      {item?.total_piece ?? 0.0}
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      {item?.charge_wt ?? 0.0}
                    </td>

                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      {getRowDescription(item?.charges) || "-"}
                    </td>

                    {/* {chargeKeys.map((key: any) => {
                      const totalCharge = item.charges?.reduce(
                        (sum, obj) => sum + (obj[key] || 0),
                        0
                      );
                      return (
                        <td
                          key={key}
                          className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                        >
                          Rs.{totalCharge ?? 0}
                        </td>
                      );
                    })} */}
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500 text-left`}
                    >
                      <div>
                        TIA :
                        {getChargeTotal(item?.charges, "tia") / item?.charge_wt}
                      </div>
                      <div>
                        FRT :
                        {getChargeTotal(item?.charges, "freight") /
                          item?.charge_wt}
                      </div>
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      {getChargeTotal(item?.charges, "tia") +
                        getChargeTotal(item?.charges, "freight")}
                    </td>
                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      Rs.{getOtherChargesTotal(item?.charges)}
                    </td>

                    <td
                      className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                    >
                      <p className={tw`text-gray-500  `}>
                        Rs.{item?.total_amount ?? 0.0}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={tw`mt-8 flex sm:justify-end`}>
            <div className={tw`w-full max-w-2xl sm:text-right space-y-2`}>
              <div className={tw`grid text-sm grid-cols-1 gap-3 `}>
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Tax:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    Rs. {order?.tax}
                  </dd>
                </dl>

                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payable Amount:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    Rs. {order?.invoice_amount}
                  </dd>
                </dl>
              </div>
              {/* End Grid */}
            </div>
          </div>
          {/* End Flex */}
          <div className={tw`mt-6 sm:mt-12`}>
            <h4 className={tw`text-lg font-semibold text-gray-500 `}>
              Thank you!
            </h4>
            <p className={tw`text-gray-500`}>
              If you have any questions concerning this statement, use the
              following contact information:
            </p>
            <div className={tw`mt-2`}>
              <p className={tw`block text-sm font-medium text-gray-500 `}>
                {clientData?.email}
              </p>
            </div>
          </div>

          <p className={tw`mt-5 text-sm text-gray-500 mx-auto`}>
            © {new Date().getFullYear()} {clientData?.business_name}.
          </p>
        </div>
      </div>
      <Modal
        isOpen={makePayment}
        setIsOpen={setMakePayment}
        title={"Make Payment"}
        children={
          <>
            <MakePayment
              setMakePayment={setMakePayment}
              payableAmount={order?.invoice_amount}
            />
          </>
        }
      />
    </>
  );
};

export default CargoInvoicePreview;
